import axiosInstance from "services/AxiosInstance";
import { ResponseType, TUser } from "types";

type GetAccountUsertListServiceArgs = (accountId?: string) => Promise<ResponseType<TUser[]>>;

export const getAccountUsers: GetAccountUsertListServiceArgs = async (accountId?: string) => {
  const response = await axiosInstance.get(`/accounts/${accountId}/users`);
  return response.data;
};
